"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandler = void 0;
var logger_utils_1 = require("./logger.utils");
/**
 * Default implementation of Error handler:
 * it logs errors in console.
 */
var ErrorHandler = /** @class */ (function () {
    function ErrorHandler() {
        this.logger = logger_utils_1.Logger.getInstance();
    }
    ErrorHandler.prototype.handle = function (error, nodeHtml) {
        this.logger.error(error);
    };
    return ErrorHandler;
}());
exports.ErrorHandler = ErrorHandler;
//# sourceMappingURL=errors.hander.js.map